export default 'ERRORS';
